"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _createSvgIcon = _interopRequireDefault(require("../createSvgIcon"));

var _CreditCardMinus = _interopRequireDefault(require("@rsuite/icon-font/lib/application/CreditCardMinus"));

// Generated by script, don't edit it please.
var CreditCardMinus = (0, _createSvgIcon["default"])({
  as: _CreditCardMinus["default"],
  ariaLabel: 'credit card minus',
  category: 'application',
  displayName: 'CreditCardMinus'
});
var _default = CreditCardMinus;
exports["default"] = _default;
module.exports = exports.default;